export default value => value.replace(/[^0-9a-zA-Z]/g, '');
